module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "form-create"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pageTitle"
    }
  }, [_vm._v("Title:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "pageTitle"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('slug-field', {
    attrs: {
      "string-to-slug": _vm.stringToSlug
    },
    on: {
      "update": _vm.updatePageSlug
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    class: {
      disabled: !_vm.active
    },
    attrs: {
      "type": "submit",
      "value": "+ Create"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("New Page")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ecb2da3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/back/home/PageCreate.vue
// module id = 264
// module chunks = 1